import React from 'react';
import styled from 'styled-components';

const RemoveAllButton = styled.button`
  border-radius: 4px;
  width: 105px;
  height: 40px;
  color: #5b36f2;
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  &:hover {
    background-color: #e2dffd;
  }
  &:focus,
  &:active {
    background-color: #c6c0fc;
  }
`;

const RemoveAllFiles = (props: any) => {
  const { handleRemoveAllFiles } = props;
  return (
    <RemoveAllButton
      onClick={handleRemoveAllFiles}
      data-testid="cmp-RemoveAllFiles"
    >
      Eliminar todo
    </RemoveAllButton>
  );
};

export default RemoveAllFiles;
